import React from 'react';
import { motion } from 'framer-motion';
import { FaUserGraduate, FaUsers, FaMedal } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const UserCategories = () => {
  const { t } = useTranslation();
  
  const categories = [
    {
      icon: <FaUserGraduate />,
      title: t('userCategories.categories.0.title'),
      description: t('userCategories.categories.0.description')
    },
    {
      icon: <FaUsers />,
      title: t('userCategories.categories.1.title'),
      description: t('userCategories.categories.1.description')
    },
    {
      icon: <FaMedal />,
      title: t('userCategories.categories.2.title'),
      description: t('userCategories.categories.2.description')
    }
  ];

  return (
    <section className="user-categories">
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 20px',
        textAlign: 'center'
      }}>
        <motion.h2 
          className="section-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          {t('userCategories.title')}
        </motion.h2>
        
        <div style={{
          maxWidth: '800px',
          margin: '0 auto 4rem',
          textAlign: 'center'
        }}>
          <p 
            className="section-description"
            style={{
              fontSize: '1.2rem',
              lineHeight: '1.8',
              color: '#4a5568',
              textAlign: 'center',
              margin: '0 auto',
              padding: '0 20px'
            }}
          >
            {t('userCategories.description')}
          </p>
        </div>
        
        <div className="categories-container">
          {categories.map((category, index) => (
            <motion.div 
              key={category.title}
              className="category-card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ 
                duration: 0.8, 
                delay: index * 0.2,
                ease: "easeOut"
              }}
            >
              <motion.div 
                className="category-icon"
                whileHover={{ scale: 1.1, rotate: 5 }}
                transition={{ duration: 0.3 }}
              >
                {category.icon}
              </motion.div>
              <h3 className="category-title">{category.title}</h3>
              <p className="category-description">{category.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UserCategories; 